import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  select: {
    color: theme.palette.lightgrey.color,
    fontWeight: 400
  },
}))
